// // src/App.js
// import React from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// import { AuthProvider } from "./rbac/AuthContext";
// import NavbarMenu from "./Pages/NavbarMenu";

// // Pages / Components
// import Home from "./Pages/Home/Home";
// import Login from "./Users/Login";
// import AdminLogin from "./Users/AdminLogin";
// import Register from "./Users/Register";
// import RegisterWithCommunity from "./Users/RegisterWithCommunity";
// import JoinRequests from "./Components/JoinRequests";

// // Community
// import CommunityHome from "./Components/Communities/CommunityHome";
// import CommunityDashboard from "./Components/Communities/CommunityDashboard";

// // Dashboards
// import AdminDashboard from "./Admin/AdminDashboard";
// import ManagerDashboard from "./Components/Manager/ManagerDashboard";
// import ResidentDashboard from "./Components/ResidentDashboard";  // or Pages/ResidentPage

// // Events
// import EventsPage from "./Components/events/EventsPage";
// import EventDetails from "./Components/events/EventDetails";
// import CreateEvent from "./Components/events/CreateEvent";
// import ManageCommittee from "./Components/events/ManageCommittee";

// // Misc
// import AddBlock from "./Components/Manager/AddBlock";

// // RBAC guards
// import { ProtectedRoute, CommunityGuard } from "./RouteGuards";
// import "./styles/app-layout.css"
// import ProfilePage from "./Pages/ProfilePage";
// import PrivacyPolicy from "./Pages/PrivacyPolicy";
// import Contact from "./Pages/Contact";
// import AboutUs from "./Pages/AboutUs";
// import PublicLayout from "./PublicLayout";
// import CheckEmail from "./utils/CheckEmail";
// import VerifySuccess from "./utils/VerifySuccess";

// function App() {
//   return (
    
//     <AuthProvider>
//       <Router>
//         <NavbarMenu />
        
// <Route element={<PublicLayout />}>
//           <Route path="/register" element={<RegisterWithCommunity />} />
//           <Route path="/check-email" element={<CheckEmail />} />
//           <Route path="/verify-success" element={<VerifySuccess />} />
// </Route>

//         <Routes>
//           {/* Public */}
//           <Route path="/" element={<Home />} />
          
//           <Route path="/login" element={<Login />} />
//           <Route path="/admin" element={<AdminLogin />} />
//           <Route path="/register-community" element={<Register />} />
//           {/* <Route path="/register" element={<RegisterWithCommunity />} /> */}
//           <Route path="/join-requests" element={<JoinRequests />} />
//           <Route path="/profile" element={<ProfilePage />} />
//           <Route path="/privacy-policy" element={<PrivacyPolicy />} />
//           <Route path="/contact" element={<Contact />} />
//           <Route path="/about-us" element={<AboutUs />} />





//           {/* Admin area (can access *all* communities) */}
//           <Route
//             path="/admin-dashboard"
//             element={
//               <ProtectedRoute allowedRoles={["admin"]}>
//                 <AdminDashboard />
//               </ProtectedRoute>
//             }
//           />
//           {/* Admin can open any community dashboard */}
//           <Route
//             path="/communities/:id"
//             element={
//               <ProtectedRoute allowedRoles={["admin"]}>
//                 <CommunityDashboard />
//               </ProtectedRoute>
//             }
//           />

//           {/* Manager area – must be manager AND belong to :communityId */}
//           <Route
//             path="/manager/:communityId"
//             element={
//               <ProtectedRoute allowedRoles={["manager"]}>
//                 <CommunityGuard>
//                   <ManagerDashboard />
//                 </CommunityGuard>
//               </ProtectedRoute>
//             }
//           />
//           {/* Managers may also use the same detailed dashboard view for their community */}
//           <Route
//             path="/community/:communityId"
//             element={
//               <ProtectedRoute allowedRoles={["manager"]}>
//                 <CommunityGuard>
//                   <CommunityDashboard />
//                 </CommunityGuard>
//               </ProtectedRoute>
//             }
//           />

//           {/* Resident area – must be resident AND belong to :communityId */}
//           <Route
//             path="/resident/:communityId"
//             element={
//               <ProtectedRoute allowedRoles={["resident"]}>
//                 <CommunityGuard>
//                   <ResidentDashboard />
//                 </CommunityGuard>
//               </ProtectedRoute>
//             }
//           />

//           {/* Events – allow all roles but gate community inside each page when needed */}
//           <Route
//             path="/events"
//             element={
//               <ProtectedRoute allowedRoles={["admin", "manager", "resident"]}>
//                 <EventsPage />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/community/:communityId/events/:eventId"
//             element={
//               <ProtectedRoute allowedRoles={["admin", "manager", "resident"]}>
//                 <CommunityGuard>
//                   <EventDetails />
//                 </CommunityGuard>
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/community/:communityId/events/new"
//             element={
//               <ProtectedRoute allowedRoles={["admin", "manager"]}>
//                 <CommunityGuard>
//                   <CreateEvent />
//                 </CommunityGuard>
//               </ProtectedRoute>
//             }
//           />

//           {/* Example: add-block only for managers inside their community */}
//           <Route
//             path="/community/:communityId/add-block"
//             element={
//               <ProtectedRoute allowedRoles={["manager"]}>
//                 <CommunityGuard>
//                   <AddBlock />
//                 </CommunityGuard>
//               </ProtectedRoute>
//             }
//           />

//           {/* Fallback community home (public preview/landing per ID if you keep it) */}
//           <Route path="/:communityId" element={<CommunityHome />} />
//         </Routes>
//       </Router>
//     </AuthProvider>
//   );
// }

// export default App;


// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { AuthProvider } from "./rbac/AuthContext";
import NavbarMenu from "./Pages/NavbarMenu";

// Pages / Components
import Home from "./Pages/Home/Home";
import Login from "./Users/Login";
import AdminLogin from "./Users/AdminLogin";
import Register from "./Users/Register";
import RegisterWithCommunity from "./Users/RegisterWithCommunity";
import JoinRequests from "./Components/JoinRequests";

// Community
import CommunityHome from "./Components/Communities/CommunityHome";
import CommunityDashboard from "./Components/Communities/CommunityDashboard";

// Dashboards
import AdminDashboard from "./Admin/AdminDashboard";
import ManagerDashboard from "./Components/Manager/ManagerDashboard";
import ResidentDashboard from "./Components/ResidentDashboard"; // or Pages/ResidentPage

// Events
import EventsPage from "./Components/events/EventsPage";
import EventDetails from "./Components/events/EventDetails";
import CreateEvent from "./Components/events/CreateEvent";
import ManageCommittee from "./Components/events/ManageCommittee";

// Misc
import AddBlock from "./Components/Manager/AddBlock";

// RBAC guards
import { ProtectedRoute, CommunityGuard } from "./RouteGuards";
import "./styles/app-layout.css";

import ProfilePage from "./Pages/ProfilePage";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import Contact from "./Pages/Contact";
import AboutUs from "./Pages/AboutUs";

// Public verification flow pages
import PublicLayout from "./PublicLayout";
import CheckEmail from "./utils/CheckEmail";
import VerifySuccess from "./utils/VerifySuccess";
import BookHomeServices from "./Services/BookHomeServices";
import { HomeFooter } from "./Pages/Home/components";

function App() {
  return (
    <AuthProvider>
      <Router>
        {/* Global navbar can sit outside Routes */}
        <NavbarMenu />

        <Routes>
          {/* ---------- PUBLIC ROUTES ---------- */}
          <Route element={<PublicLayout />}>
            <Route path="/register" element={<RegisterWithCommunity />} />
            <Route path="/check-email" element={<CheckEmail />} />
            <Route path="/verify-success" element={<VerifySuccess />} />
          </Route>

          {/* Basic public pages */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/register-community" element={<Register />} />
          <Route path="/join-requests" element={<JoinRequests />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about-us" element={<AboutUs />} />

          {/* ---------- Services Section ---------- */}

          
          {/* <Route path="/services/book-home" element={<BookHomeServices />} /> */}
          <Route path="/services/book/:slug" element={<BookHomeServices />} />

          
          

          {/* ---------- PROTECTED / ROLE-BASED ROUTES ---------- */}
          {/* Admin area (can access *all* communities) */}
          <Route
            path="/admin-dashboard"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          {/* Admin can open any community dashboard */}
          <Route
            path="/communities/:id"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <CommunityDashboard />
              </ProtectedRoute>
            }
          />

          {/* Manager area – must be manager AND belong to :communityId */}
          <Route
            path="/manager/:communityId"
            element={
              <ProtectedRoute allowedRoles={["manager"]}>
                <CommunityGuard>
                  <ManagerDashboard />
                </CommunityGuard>
              </ProtectedRoute>
            }
          />
          {/* Managers may also use the detailed dashboard view for their community */}
          <Route
            path="/community/:communityId"
            element={
              <ProtectedRoute allowedRoles={["manager"]}>
                <CommunityGuard>
                  <CommunityDashboard />
                </CommunityGuard>
              </ProtectedRoute>
            }
          />

          {/* Resident area – must be resident AND belong to :communityId */}
          <Route
            path="/resident/:communityId"
            element={
              <ProtectedRoute allowedRoles={["resident"]}>
                <CommunityGuard>
                  <ResidentDashboard />
                </CommunityGuard>
              </ProtectedRoute>
            }
          />

          {/* Events – allow roles but gate by community when needed */}
          <Route
            path="/events"
            element={
              <ProtectedRoute allowedRoles={["admin", "manager", "resident"]}>
                <EventsPage />
              </ProtectedRoute>
            }
          />

          {/* Example: add-block only for managers inside their community */}
          <Route
            path="/community/:communityId/add-block"
            element={
              <ProtectedRoute allowedRoles={["manager"]}>
                <CommunityGuard>
                  <AddBlock />
                </CommunityGuard>
              </ProtectedRoute>
            }
          />

          <Route
            path="/community/:communityId/events/:eventId"
            element={
              <ProtectedRoute allowedRoles={["admin", "manager", "resident"]}>
                <CommunityGuard>
                  <EventDetails />
                </CommunityGuard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/community/:communityId/events/new"
            element={
              <ProtectedRoute allowedRoles={["admin", "manager"]}>
                <CommunityGuard>
                  <CreateEvent />
                </CommunityGuard>
              </ProtectedRoute>
            }
          />

          {/* Fallback community home (public preview/landing per ID if you keep it) */}
          <Route path="/:communityId" element={<CommunityHome />} />
        </Routes>
      </Router>
       {/* <HomeFooter/> */}
    </AuthProvider>
   
  );
}

export default App;
